import { FavoriteMedicineCreateIcon } from './FavoriteMedicineCreate/FavoriteMedicineCreateIcon';
import { FavoriteMedicineDeleteIcon } from './FavoriteMedicineDelete/FavoriteMedicineDeleteIcon';

type FavoriteMedicineIconProps = {
   readonly favorite: boolean;
   readonly medicineId: number;
   readonly medicineValid: boolean;
   readonly onMedicineProcessed: VoidFunction;
};

export const FavoriteMedicineIcon = (props: FavoriteMedicineIconProps): JSX.Element => {
   if (props.favorite) {
      return (
         <FavoriteMedicineDeleteIcon
            medicineId={props.medicineId}
            onSuccess={props.onMedicineProcessed}
            medicineValid={props.medicineValid}
         />
      );
   }

   return <FavoriteMedicineCreateIcon medicineId={props.medicineId} onSuccess={props.onMedicineProcessed} />;
};
